var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhotoLibrary = function SvgPhotoLibrary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.077 14.096h9.346l-3.104-4.077-2.377 3.039-1.569-1.942zm-1.02 3.654q-.756 0-1.282-.525a1.75 1.75 0 0 1-.525-1.283V4.558q0-.758.525-1.283t1.283-.525h11.384q.758 0 1.283.525t.525 1.283v11.384q0 .758-.525 1.283t-1.283.525zm0-1.5h11.385a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212V4.558a.3.3 0 0 0-.096-.212.3.3 0 0 0-.212-.096H8.058a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212v11.384q0 .116.096.212a.3.3 0 0 0 .212.096m-3.5 5q-.756 0-1.282-.525a1.75 1.75 0 0 1-.525-1.283V6.558h1.5v12.884q0 .116.096.212a.3.3 0 0 0 .212.096h12.884v1.5z"
  })));
};
export default SvgPhotoLibrary;